// @utilities
const { formatText } = require('core/i18n').i18n;

const getBreadCrumbSettings = () => [{
    text: formatText('breadcrumb-global'),
    url: '/myprofile/global'
},
{
    text: formatText('breadcrumb-aggregatorSettingsPG'),
    url: '/myprofile/global/entities/manage'
},
{
    text:formatText('breadcrumb-renewPsd2Session'),
    url: ''
}]

export default getBreadCrumbSettings;